"use client";

import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import styles from "./Tooltip.module.css";

/**
 * Thin wrapper around @radix-ui/react-tooltip.
 *
 * Mirrors the shape of the Popover wrapper in this codebase:
 *   - `Tooltip` re-exports `Root` as-is
 *   - `TooltipTrigger` re-exports `Trigger` as-is
 *   - `TooltipContent` wraps `Portal + Content`, applies the project's
 *     style tokens via CSS Modules, and forwards refs cleanly
 *
 * NOTE: Radix Tooltip requires a single `<TooltipProvider>` mounted near
 * the application root. It is wired in `main.tsx` — do NOT add another
 * provider per-component.
 */
const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 6, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={`${styles.content} ${className ?? ""}`}
      {...props}
    />
  </TooltipPrimitive.Portal>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipProvider, TooltipTrigger, TooltipContent };
